import type { AuthService } from "../auth/services/auth.service";
import type { HttpAdapter } from "../core/adapters/axios.adapter";
import type { Eligibility } from "./newsletter.models";

export class NewsletterService {
    constructor(private newsletterAdapter: HttpAdapter, private authService: AuthService = window.tbwServices.authService) {
    }

    async checkEligibility(nlId: string): Promise<Eligibility> {
        try {
            if (!this.authService.isAuthenticated || !nlId) { throw new Error("Token or nlId not provided") }
            const response = await this.newsletterAdapter.get(`/${nlId}`)

            return response.data;
        }
        catch (error) {
            throw error
        }
    }

    async subscribe(email: string, nlId: string): Promise<any> {
        try {
            if (!nlId) { throw new Error("NlId not provided") }
            if (!this.authService.isAuthenticated && !email) { throw new Error("Either token or email must be provided") }

            const data = JSON.stringify(email ? { email } : {})

            const response = await this.newsletterAdapter.post(`/${nlId}`, data)
            return response.data;
        }
        catch (error) {
            throw error
        }
    }

    async unsubscribe(nlId: string) {
        try {
            if (!this.authService.isAuthenticated || !nlId) { throw new Error("Token or nlId not provided") }

            const response = await this.newsletterAdapter.delete(`/${nlId}`);
            return response.data;
        }
        catch (error) {
            throw error
        }
    }
}
